<template>
  <div class="text-center">
    <v-snackbar :timeout="0" v-model="show" :multi-line="multiLine">
      {{ getAlertMsj }}
      <v-btn color="red" text @click="close">CERRAR</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'AlertMsj',
  props: {
    visible: {
      type: Boolean,
    },
  },
  data: () => ({
    multiLine: true,
    snackbar: null,
  }),
  methods: {
    ...mapActions(['alertGeneral']),
    close() {
      this.alertGeneral(false, '')
    },
  },
  computed: {
    ...mapGetters(['getAlertFlat', 'getAlertMsj']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
  },
}
</script>

<style scoped></style>
